import { forwardRef } from "react"
import NextLink, { type LinkProps as NextLinkProps } from "next/link"

type LinkProps = NextLinkProps &
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    children?: React.ReactNode
  }

const isExternalLink = (href: string): boolean => {
  return (
    href.startsWith("http://") || href.startsWith("https://") || href.startsWith("//")
  )
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ prefetch = false, children, href, target, rel, ...rest }, ref) => {
    const isExternal = typeof href === "string" && isExternalLink(href)

    if (isExternal) {
      return (
        <a
          href={href as string}
          target={target || "_blank"}
          rel={rel || "noopener noreferrer"}
          ref={ref}
          {...rest}
        >
          {children}
        </a>
      )
    }

    return (
      <NextLink
        {...rest}
        href={href}
        prefetch={prefetch}
        ref={ref}
        target={target}
        rel={rel}
      >
        {children}
      </NextLink>
    )
  },
)

Link.displayName = "Link"

export default Link
